import { cookieStore } from '@flipster/utils/cookie';
import { isServer } from '@flipster/utils/env-helper';

if (!isServer) {
  window.onload = () => {
    // 쿼리스트링으로 넣어준 fbc 쿠키에 넣어두고 회원가입시 넣어준다
    const searchParams = new URLSearchParams(window.location.search);
    const fbc = searchParams.get('fbc');
    if (fbc) cookieStore.update('fbc', fbc, 60);
  };
}
